export const CURRENCIES = [
  { value: 'RUB', label: 'Рубль' },
  { value: 'USD', label: 'Доллар' },
  { value: 'EUR', label: 'Евро' }
]

export const ORGANIZATION_TYPES = [
  { value: 'ООО', label: 'ООО' },
  { value: 'ЗАО', label: 'ЗАО' },
  { value: 'ИП', label: 'ИП' },
  { value: 'OAO', label: 'OAO' },
  { value: 'АО', label: 'АО' },
  { value: 'LLP', label: 'ЛЛП' },
  { value: 'ZOO', label: 'Z.O.O.' },
  { value: 'ПАО', label: 'ПАО' },
]

export const SPACE_LIMITS_EDITOR_ROLES = [
  'ROLE_ACCOUNT_MANAGER',
  'ROLE_ADMIN',
  'ROLE_SUPER_USER'
]

export const CLASS_OF_SERVICE = [
  { value: 'Base', label: 'Base' },
  { value: 'Pro', label: 'Pro' },
  { value: 'Premium', label: 'Premium' }
]
